<template>
  <div class="col-12">
    <z-form ref="form" @submit.native.prevent="save">
      <div class="row">
        <div class="z-card border-0">
          <div class="row">
            <div class="col-6">
              <base-form ref="form" v-model="form" />
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-6">
              <number-form />
            </div>
          </div>

          <div v-if="is_edit" class="row mt-4">
            <div class="col-6">
              <number-list />
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <i-button type="primary" size="large" html-type="submit" :loading="loading">
          {{ $t('shared.component.button.save') }}
        </i-button>
      </div>
    </z-form>
  </div>
</template>
<script>
  import BaseForm from './base-form';
  import NumberForm from './number-form';
  import NumberList from './number-list';

  import { mapGetters } from 'vuex';
  import { PhoneListService } from '@pbx/services/PhoneListService';
  import { PhoneService } from '@pbx/services/PhoneService';
  import { isID } from '@shared/helpers/uid';
  import { PageServerValidationResponseMixin } from '@shared/mixins/page-server-validation-response';

  export default {
    components: {
      BaseForm,
      NumberForm,
      NumberList
    },
    mixins: [PageServerValidationResponseMixin],
    props: {
      id: {
        type: [Number, String],
        default: null
      },
      item: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      form: {},
      loading: false
    }),

    computed: {
      ...mapGetters('pbx/phone-lists/form/table', ['changes']),

      is_edit: function () {
        return isID(this.id);
      },

      added: function () {
        return this.changes.filter((f) => f.state === 'add');
      },

      removed: function () {
        return this.changes.filter((f) => f.state === 'remove');
      }
    },

    watch: {
      item: {
        handler: function (item) {
          this.form = { ...item };
        },
        immediate: true
      }
    },

    methods: {
      save(e) {
        e.preventDefault();

        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.loading = true;

            const request = this.is_edit
              ? PhoneListService.editItem(this.id, this.form)
              : PhoneListService.createItem(this.form);

            request
              .then((res) => {
                const removed_requests = this.removed.map((r) =>
                  PhoneService.removeItem(res.id, r.id)
                );
                const added_requests = this.added.map((a) =>
                  PhoneService.createItem(res.id, {
                    phone: a.phone,
                    list_id: res.id
                  })
                );

                return Promise.all([...removed_requests, ...added_requests]);
              })
              .then(() => this.$router.push({ name: 'pbx.phone-list.index' }))
              .catch((error) => this.check_server_validation(error))
              .finally(() => (this.loading = false));
          }
        });
      }
    }
  };
</script>
